<div class="points-summary-bar d-flex justify-content-between d-lg-none my-2 w-100">
  <!-- Back Button -->
  <div class="rewards-back-button cursor-pointer d-flex align-items-center d-lg-none ms-3" (click)="goBack()">
    <span class="material-icons align-middle fw-bold text-white">navigate_before</span>
  </div>

  <!-- Points Bar -->
  <div class="points-bar me-3">
    <fgb-points-summary></fgb-points-summary>
  </div>
</div>
